.ar{overflow:hidden;}